import { Component, inject, OnDestroy } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LoadingFailedHintComponent } from '@libs/ui';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { ReportingGridComponent } from 'demand-forecasting/reporting/components/reporting-grid/reporting-grid.component';
import { ReportingToolbarComponent } from 'demand-forecasting/reporting/components/reporting-toolbar/reporting-toolbar.component';
import { ReportingStateService } from 'demand-forecasting/reporting/services/reporting-state.service';
import { ConfigurationsSelectors } from 'demand-forecasting/store/configurations/configurations.selectors';

@Component({
  selector: 'pm-reporting-page',
  templateUrl: './reporting-page.component.html',
  host: { class: 'flex flex-col h-full gap-4' },
  imports: [
    TranslateModule,
    MatProgressSpinner,
    LoadingFailedHintComponent,
    ReportingToolbarComponent,
    ReportingGridComponent,
  ],
  providers: [ReportingStateService],
})
export class ReportingPageComponent implements OnDestroy {
  private readonly store = inject(Store);
  protected readonly reportingState = inject(ReportingStateService);

  protected readonly additionalTimeSeriesNames = this.store.selectSignal(
    ConfigurationsSelectors.selectAdditionalTimeSeriesNames,
  );

  ngOnDestroy(): void {
    this.reportingState.resetState();
  }
}
